import { ReactNode } from 'react';

import { Typography } from '@spotnana/blocks/src/Typography';
import Box, { BoxProps, Flex } from '@spotnana/pixel-react/dist/Box';
import Divider from '@spotnana/pixel-react/dist/Divider';
import theme from '@spotnana/pixel-react/dist/utils/themes/theme';

import CardDetailAction from './CardDetailAction';

import { card_detail_item_title } from './CardDetailItem.styles';

interface CardDetailItemProps {
  title: string;
  children: string | ReactNode;
  containerProps?: Omit<BoxProps, 'theme' | 'color'>;
  actionTitle?: string;
  dividerDisplay?: string;
  onClickAction?: () => void;
  childrenWrapperProps?: Omit<BoxProps, 'theme' | 'color'>;
  dataTestId?: string;
}

const CardDetailItem = ({
  title,
  children,
  actionTitle,
  onClickAction,
  containerProps,
  dividerDisplay,
  childrenWrapperProps,
  dataTestId,
}: CardDetailItemProps): JSX.Element => {
  let childrenWrapper = (
    <Box pb="2" {...childrenWrapperProps}>
      <Box py={12} display={dividerDisplay}>
        <Divider backgroundColor={theme.colors.surfaceDividerStrong} />
      </Box>
      {children}
    </Box>
  );

  if (typeof children === 'string') {
    childrenWrapper = (
      <Typography variant="body3" data-testid="date-time-info" {...childrenWrapperProps}>
        {children}
      </Typography>
    );
  }

  return (
    <Box flexGrow={1} mb="16px" mx={{ xs: '-24px', sm: '0px' }} {...containerProps} data-testid={dataTestId}>
      <Flex pt="8px" pb="4px" justifyContent="space-between" alignItems="center">
        <Typography css={card_detail_item_title} kind="semibold" variant="body3" as="h3">
          {title}
        </Typography>
        {actionTitle && <CardDetailAction onClickAction={onClickAction}>{actionTitle}</CardDetailAction>}
      </Flex>

      {childrenWrapper}
    </Box>
  );
};

CardDetailItem.displayName = 'CardDetailItem';
export default CardDetailItem;
